import {
  Box,
  Divider,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import React, { Dispatch, useEffect, useState } from 'react';
import CachedIcon from '@mui/icons-material/Cached';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { getDate, getDay, getMonth, getYear } from 'date-fns';
import {
  getDateList,
  getMonthDates,
  getYearDateList,
} from '../../common/helper';
import { useSession } from '../../hooks/session';

interface Props {
  includeAll?: boolean;
  showSelectDay?: boolean;
  onChangeMonth: (month: number) => void;
  onChangeDay?: (day: number) => void;
}

export const SwSelectMonth: React.FC<Props> = ({
  includeAll = false,
  showSelectDay = true,
  onChangeMonth,
  onChangeDay,
}) => {
  const { loginVal } = useSession();
  const [dateList, setDateList] = useState<any[]>([]);
  const [monthDateList, setMonthDateList] = useState<any[]>([]);
  const [selectMonth, setSelectMonth] = useState<number>(0);
  const [selectDate, setSelectDate] = useState<number>(0);

  const changeMonth = (month: number) => {
    if (month !== 0) {
      setSelectMonth(month);
      setMonthDateList(getMonthDates(month * 1000));
      setSelectDate(0);
      onChangeMonth(month);
    } else {
      setSelectDate(0);
      setSelectMonth(month);
      onChangeMonth(month);
    }
  };

  useEffect(() => {
    onChangeDay && onChangeDay(selectDate);
  }, [selectDate]);

  useEffect(() => {
    const currentDate = new Date();
    const currentYear = getYear(currentDate);
    const targetYear = loginVal.value.user.year
      ? loginVal.value.user.year
      : currentYear;
    const newDataList = getYearDateList(targetYear);
    setDateList(newDataList);
    setSelectMonth(includeAll ? 0 : newDataList[0]);
    setMonthDateList(getMonthDates(newDataList[0] * 1000));
  }, []);

  return (
    <Box>
      <TextField
        sx={{ width: '10rem', mr: '.5rem' }}
        select
        value={selectMonth}
        onChange={evt => changeMonth(Number(evt.target.value))}
      >
        {includeAll && (
          <MenuItem key={`date_${0}`} value={0}>
            선택
          </MenuItem>
        )}
        {dateList.map((item, index) => (
          <MenuItem key={`date_${index + 1}`} value={item}>
            {`${getYear(item * 1000)}년 ${
              getMonth(item * 1000) + 1 < 10
                ? `0${getMonth(item * 1000) + 1}`
                : getMonth(item * 1000) + 1
            }월`}
          </MenuItem>
        ))}
      </TextField>
      {showSelectDay && (
        <TextField
          sx={{ width: '8rem' }}
          select
          value={selectDate}
          onChange={evt => setSelectDate(Number(evt.target.value))}
        >
          <MenuItem key={`month_date_${0}`} value={0}>
            전체
          </MenuItem>
          {monthDateList.map((item, index) => (
            <MenuItem key={`month_date_${index + 1}`} value={getDate(item)}>
              {`${getDate(item)}일`}
            </MenuItem>
          ))}
        </TextField>
      )}
    </Box>
  );
};
